import ms from 'ms';

import { SearchAuctionFacet, SearchAuctionResult } from '@/redux/modules/auctionCalendar/auctionCalendar.api';

export type AuctionCalendarSlice = {
    catalogIds: number[];
    catalogsTodayCount: number;
    error: boolean;
    facets: SearchAuctionFacet[];
    submitted: boolean;
    success: boolean;
    totalFound: number;
    upcomingAuctionsCount: number | null;
    upcomingAuctionsCountLoadTime: number;
};

export const defaultAuctionCalendarSlice: AuctionCalendarSlice = {
    catalogIds: [],
    catalogsTodayCount: 0,
    error: false,
    facets: [],
    submitted: false,
    success: false,
    totalFound: 0,
    upcomingAuctionsCount: null,
    upcomingAuctionsCountLoadTime: 0,
};

// Same window as home data, so a long-lived homepage tab can't drift far from the calendar
export const UPCOMING_AUCTIONS_COUNT_CACHE_TIME = ms('5m');

export type AuctionCalendarPayload = {
    count: number;
    facets: SearchAuctionFacet[];
    results: SearchAuctionResult[];
};

export type TodaysCatalogCount = { count: number };
export type TodaysCatalogCountApiResponse = [TodaysCatalogCount];
